import { render } from "./publicEducationalItem.vue?vue&type=template&id=61b9bf0f"
import script from "./publicEducationalItem.vue?vue&type=script&lang=js"
export * from "./publicEducationalItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__